import { CommonModule } from '@angular/common';
import { Component, forwardRef, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { CiselnikItemXmlDto } from '../../dto/CiselnikItemXmlDto';
import { SelectItem } from '../../interfaces/select-item';
import { CiselnikyUtils } from '../../Utils/ciselniky.utils';

/**
 * Komponenta dropdown pro práci s číselníky.
 */
@Component({
	selector: 'app-ciselnik-dropdown',
	templateUrl: './ciselnik-dropdown.component.html',
	styleUrls: ['./ciselnik-dropdown.component.css'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => CiselnikDropdownComponent),
		multi: true
	}],
	imports: [SelectModule, CommonModule, FormsModule],
	standalone: true
})
export class CiselnikDropdownComponent implements ControlValueAccessor {

	private _id = '';
	private _inputId = '';
	protected _nullable: boolean = false;
	protected _rawData: CiselnikItemXmlDto[] = [];
	data: CiselnikItemXmlDto[] = [];

	// Proměnné pro implementaci rozhraní ControlValueAccessor
	onModelChange: any = () => { };
	onModelTouched: any = () => { };
	disabled: boolean = false;

	// finta s ID odkoukána zde: https://coryrylan.com/blog/angular-custom-form-controls-with-reactive-forms-and-ngmodel
	@HostBinding('attr.id')
	externalId = '';

	constructor(private ciselnikyUtils: CiselnikyUtils) { }


	@Input()
	set id(value: string) {
		this._id = value;
		this.externalId = null;
	}

	get id() {
		return this._id;
	}

	@Input()
	set inputId(value: string) {
		this._inputId = value;
	}

	get inputId() {
		return this._inputId;
	}

	private _headerStyle: boolean = false;
	@Input()
	set headerStyle(value: boolean) {
		this._headerStyle = value;
	}

	get headerStyle() {
		return this._headerStyle;
	}

	/**
	 * True, pokud je komponenta vnořená uvnitř app-outlined-field - odstraní vlastní okraj/výšku
	 * p-select (viz styles.css), aby splynula s obalujícím fieldsetem stejně jako input uvnitř
	 * app-outlined-input.
	 */
	@Input() outlinedStyle: boolean = false;

	//filtr číselníku podle popisu
	@Input() filter: boolean = false;

	@Input('value') _value: any = null;

	get value() {
		return this._value;
	}

	set value(val) {
		if (val != null && (val.label != null || val.value != null)) {
			val = this.ciselnikyUtils.SelectItemToCiselik(val);
		}

		if (val != this._value) {
			//Pokud se nejedná o objekt CiselnikItemXmlDto, kde je povinný kód, tak vyprázdnit.
			if (!val?.kod) {
				val = null;
			}

			this._value = val;
			this.onModelChange(val);
			this.onModelTouched();
		}
	}


	@Input()
	set nullable(value: boolean) {
		if (value != this._nullable) {
			this._nullable = value;
			this.buildData();
		}
	}

	@Input()
	set ciselnikData(value: SelectItem[]) {
		if (value != void 0) {
			this._rawData = value.map(x => { return { popis: x.label, kod: x.value } });
			this.buildData();
		}
	}

	/**
	 * True, pokud se má použít virtuální scrollování
	 */
	@Input() virtualScroll: boolean = false;

	// Implementace rozhraní ControlValueAccessor
	writeValue(obj: any): void {
		this.value = obj;
	}

	// Implementace rozhraní ControlValueAccessor
	registerOnChange(fn: any): void {
		this.onModelChange = fn;
	}

	// Implementace rozhraní ControlValueAccessor
	registerOnTouched(fn: any): void {
		this.onModelTouched = fn;
	}

	// Implementace rozhraní ControlValueAccessor
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	/**
	 * Seřadí položky podle kódu a přidá prázdnou, pokud je povolená
	 */
	protected buildData(): void {
		var auxData = this._rawData.sort((a, b) => { return Number(a.kod) - Number(b.kod); });

		if (this._nullable) {
			this.data = ([{ popis: " ", kod: null }] as CiselnikItemXmlDto[]).concat(auxData);
		}
		else {
			this.data = auxData;
		}
	}
}
